import { render, staticRenderFns } from "./Datagraph7.vue?vue&type=template&id=84317be8&scoped=true"
import script from "./Datagraph7.vue?vue&type=script&lang=js"
export * from "./Datagraph7.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84317be8",
  null
  
)

export default component.exports